import MultiCodeEditorInteractiveBase from 'components/patterns/MultiCodeEditor/MultiCodeEditorInteractive'
import { withContainer } from 'helpers/hoc/with-container'

export const MultiCodeEditorInteractive = withContainer(
  MultiCodeEditorInteractiveBase
)
